import React, { useState } from "react";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "../ui/tooltip";

/**
 * Ícone "?" com texto de ajuda contextual — aparece ao passar o mouse (hover,
 * via Radix Tooltip, já usado em outras partes do design system) e também ao
 * clicar/tocar (importante em telas touch, onde não existe hover de verdade).
 *
 * Reutilizável em qualquer tela do CRM: só passar `text`. Requer que
 * <TooltipProvider> esteja montado acima na árvore (já feito uma vez em
 * App.js, então nenhuma outra tela precisa se preocupar com isso).
 *
 * Uso:
 *   <label className="flex items-center gap-1.5">
 *     Responsável
 *     <HelpTooltip text="Quem vai receber as conversas deste canal." />
 *   </label>
 */
export default function HelpTooltip({
  text,
  side = "top",
  className = "",
  contentClassName = "",
  iconSize = 14,
  testId = "help-tooltip",
}) {
  const [open, setOpen] = useState(false);

  if (!text) return null;

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={(event) => {
            // Não deixa o clique "vazar" pro elemento pai (ex: um card ou
            // label clicável) -- o "?" só deve abrir/fechar a própria dica.
            event.stopPropagation();
            event.preventDefault();
            setOpen((prev) => !prev);
          }}
          className={`inline-flex items-center justify-center shrink-0 w-4 h-4 rounded-full text-slate-500 hover:text-[#25D366] focus:text-[#25D366] outline-none transition-colors ${className}`}
          aria-label="Ajuda"
          data-testid={testId}
        >
          <HelpCircle size={iconSize} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className={`max-w-[260px] bg-slate-800 border border-slate-700 text-slate-100 text-xs leading-relaxed py-2 px-3 shadow-xl ${contentClassName}`}
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
